import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { PrinterService } from '../../providers/printglobal/printer.service';
import { CajaProvider } from '../../providers/caja/caja'
import { Storage } from '@ionic/storage'
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils';
import { CompaniasProvider } from '../../providers/companias/companias';

@Component({
  selector: 'intereses-creditos',
  templateUrl: 'intereses-creditos.html',
  providers: [ PrinterService,CajaProvider ]
})
export class InteresesCreditosComponent {
  numeroCuota: string;
  valor: number;
  interesCreditos:any[] = []
  companiasId:any = 0
  loader
  arrastrarValor:string = 'N'
  arrastrarValorTexto:string = 'No'
  constructor(public navCtrl: NavController, public toastCtrl: ToastController, public utils:UtilsProvider,public cajaProvider:CajaProvider,
    public servicioCompania: CompaniasProvider, public loadingCtrl: LoadingController
  ) {
    this.buscarPermisosPorCompania()
    this.buscarIntereses()
   }

   async buscarIntereses(){
    let val = await this.servicioCompania.devolverVariosAsync(['companiasId','usuariosId', 'nombreCargo'])
    if(val){
          this.companiasId = val['companiasId'];
          this.cajaProvider.buscarIntereses(this.companiasId).subscribe(async (data: any)=>{
            if(NUBE_AWS) {
              data = JSON.parse(data['_body']).data[0]
              this.interesCreditos = data
            }
          },(error)=> console.log(error))
    }


  }

  async buscarPermisosPorCompania() {
    const tienePermiso = await this.utils.verificarPermiso(
      'InteresesCreditosComponent',
      'Interés de Créditos',
      'No ha adquirido el módulo de créditos. Por favor, contacte a su administrador para más información.'
    );

    if (!tienePermiso) {
      this.navCtrl.pop(); // Solo si no tiene permiso, vuelve atrás
    }
  }

  guardarCuenta() {
    // Verificar si la cuenta ya existe
    const cuentaExistente = this.interesCreditos.find(cuenta => cuenta.numeroCuota == this.numeroCuota);
    this.loader = this.loadingCtrl.create({});
    this.loader.present();
    if (cuentaExistente) {
      // Actualizar la cuenta existente
      cuentaExistente.interes = this.valor;
      let datosInteresCredito: any = {
        interesesCreditosId: cuentaExistente.interesesCreditosId,
        companiasId: cuentaExistente.companiasId,
        numeroCuota: this.numeroCuota,
        valor:this.valor,
        queHago: "A",
        nombreTabla: "interesesCreditos",
        name: "dataDynamicCrud"
      }
      let companiasId = cuentaExistente.companiasId
      let valor = this.valor
      this.servicioCompania.gestionarInteresesCreditos(datosInteresCredito).subscribe((item)=>{
         this.buscarIntereses()
         this.loader.dismiss()
         this.utils.mensajeMuestro('Interes créditos','Registro actualizado con exito','success')
         if(this.arrastrarValor === 'S'){
          this.servicioCompania.gestionarInteresesCreditosArrastrarValor(companiasId,valor).subscribe((item)=>{
            this.arrastrarValor = 'N'
            this.arrastrarValorTexto = 'NO'
            this.buscarIntereses()
           },(error)=> console.log(error))
         }
       }, (error)=> {
        this.loader.dismiss()
        this.buscarIntereses()
        this.utils.mensajeMuestro('Interes créditos','El registro no se logro actualizar verifique','warning')
      })




    } else {
      // Guardar una nueva cuenta
      this.interesCreditos.push({ numeroCuenta: this.numeroCuota, interes: this.valor });
      let datosInteresCredito: any = {
        companiasId: this.companiasId,
        numeroCuota: this.numeroCuota,
        valor:this.valor,
        queHago: "I",
        nombreTabla: "interesesCreditos",
        name: "dataDynamicCrud"
      }
      this.servicioCompania.gestionarInteresesCreditos(datosInteresCredito).subscribe((item)=>{
        this.loader.dismiss()
        this.buscarIntereses()
        this.utils.mensajeMuestro('Interes créditos','Registro guardado con exito','success')
      }, (error)=> {
        this.loader.dismiss()
        this.buscarIntereses()
        this.utils.mensajeMuestro('Interes créditos','El registro no se logro guardar verifique','warning')
       })

    }

    // Limpiar los campos después de guardar
    this.numeroCuota = '';
    this.valor = null;
    this.loader.dismiss()
  }

  eliminarCuenta(item: any) {
    this.interesCreditos = this.interesCreditos.filter(cuenta => cuenta['numeroCuota'] == item['numeroCuota']);
    this.utils.mensajeConfirmacionDos('Interes créditos','¿Está seguro de eliminar el registro?','question','Si','No')
    .then((laRespuesta: boolean) =>{
      if (laRespuesta){
        this.loader = this.loadingCtrl.create({});
        this.loader.present();
        let datosInteresCredito: any = {
          companiasId: item.companiasId,
          numeroCuota: item.numeroCuota,
          valor:item.valor,
          interesesCreditosId: item.interesesCreditosId,
          queHago: "E",
          nombreTabla: "interesesCreditos",
          name: "dataDynamicCrud"
        }

          this.servicioCompania.gestionarInteresesCreditos(datosInteresCredito)
          .subscribe(
          res => {
            this.loader.dismiss()
            this.buscarIntereses()
            this.utils.mensajeMuestro('Interes créditos','Registro eliminado con Éxito!','success')
          },
          err => {
            this.loader.dismiss()
            this.buscarIntereses()
            this.utils.mensajeMuestro('Interes créditos','El registro no se logro eliminar verifique','warning')
          }
          )
      }
      else {
        this.loader.dismiss()
        this.buscarIntereses()
        this.utils.mensajeMuestro('Interes créditos','El registro no se logro eliminar verifique','warning')
      }
    })
  }

  mostrarMensaje(mensaje: string) {
    let toast = this.toastCtrl.create({
      message: mensaje,
      duration: 2000,
      position: 'bottom'
    });
    toast.present();
  }
  toggleArrastrarValor() {
    this.arrastrarValor = this.arrastrarValor === 'N' ? 'S' : 'N';
    if(this.arrastrarValor === 'N') {
      this.arrastrarValorTexto = 'NO'
    } else {
      this.arrastrarValorTexto = 'SI'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intereses-creditos/intereses-creditos.ts